import { Typography } from "@mui/material";
import HelpDialogLayout, {
  BodyTypographies,
  ContentStack,
  HelpDialogLayoutProps,
  HelpDialogLink,
  SectionStack,
} from "./HelpDialogLayout";

export interface ContactDialogProps extends HelpDialogLayoutProps {}
export default function ContactDialog(props: HelpDialogLayoutProps) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <SectionStack>
          <BodyTypographies
            contents={[
              "レポートの結果を受けて睡眠について心配なことがある時、またその他に相談したいことがある時は下記のような相談先があります。",
              "",
              "医師：睡眠は心療内科・精神科で取り扱われていることが多く、科としては標ぼうされていませんが睡眠外来や睡眠クリニックも多く存在します。",
              "保健師：保健指導の一環で睡眠を指導をしている保健師さんもいらっしゃるので健康保険組合や健診機関で健康診断を受けた際には相談してみるとよいでしょう。",
            ]}
          />
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2" color="#3D3D3D">
            インターネット上の情報：
          </Typography>
          <ContentStack>
            <BodyTypographies
              contents={[
                <Typography variant="caption">
                  厚生労働省 睡眠ガイド 2023
                </Typography>,
                <HelpDialogLink href="https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/kenkou_iryou/kenkou/suimin/index.html" />,
                <Typography variant="caption">
                  厚生労働省 e-健康づくりネット
                </Typography>,
                <HelpDialogLink href="https://e-kennet.mhlw.go.jp/tools_sleep/" />,
                <Typography variant="caption">
                  スマートライフプロジェクト
                </Typography>,
                <HelpDialogLink href="https://www.smartlife.mhlw.go.jp/event/sleep_quality/" />,
              ]}
            />
          </ContentStack>
        </SectionStack>
      </ContentStack>
    </HelpDialogLayout>
  );
}
